import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { UserData } from 'src/app/interfaces/user/user.interface';
import { AuthService } from 'src/app/services/api/auth/auth.service';

@Component({
  selector: 'app-complete-register',
  templateUrl: './complete-register.component.html',
  styleUrls: ['./complete-register.component.scss'],
})
export class CompleteRegisterComponent implements OnInit {
  @Input() userData: UserData;
  @Output() close = new EventEmitter<void>();
  completeRegister: FormGroup;
  errorRegister: string | null = null;
  successRegister: boolean = false;
  registerIn = false;
  showPassword1 = false;
  showPassword2 = false;
  completeProfile: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    if (this.userData) {
      this.populateForm(this.userData);
    }
  }

  private initializeForm(): void {
    this.completeRegister = this.fb.group({
      document: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^[0-9]*$/)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8), this.passwordComplexityValidator()]],
      confirmPassword: ['', [Validators.required]],
      tyc_shellbox_accepted: [false, Validators.requiredTrue],
      tyc_marketshell_accepted: [false],
      optin: [false],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      number: ['', [Validators.required]],
      areaCode: ['', [Validators.required]],
    }, {
      validators: this.matchPasswords('password', 'confirmPassword'),
    });
  }

  private populateForm(userData: UserData): void {
    this.completeRegister.patchValue({
      document: userData.document.number,
      email: userData.email,
      firstname: userData.firstname,
      lastname: userData.lastname,
      tyc_shellbox_accepted: userData.tyc_shellbox_accepted,
      tyc_marketshell_accepted: userData.tyc_marketshell_accepted,
      number: userData.cellphone?.number,
      areaCode: userData.cellphone?.areaCode,
      intCode: '549'
    });
  }

  private passwordComplexityValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.value;
      const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);
      return isValid ? null : { passwordComplexity: true };
    };
  }

  private matchPasswords(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmPassword);

      if (passwordControl?.value !== confirmPasswordControl?.value) {
        confirmPasswordControl?.setErrors({ passwordMismatch: true });
        return { passwordMismatch: true };
      } else {
        confirmPasswordControl?.setErrors(null);
        return null;
      }
    };
  }

  nextStep(): void {
    this.errorRegister = null;
    if (this.completeRegister.invalid) {
      this.errorRegister = 'Por favor completa los campos requeridos.';
      return;
    }
  
    this.registerIn = true;
  
    const registerData = {
      userUpdate: {
        profile: {
          document: {
            number: this.completeRegister.value.document,
            type: 1
          },
          email: this.completeRegister.value.email,
          firstname: this.completeRegister.value.firstname,
          lastname: this.completeRegister.value.lastname,
          tyc_shellbox_accepted: this.completeRegister.value.tyc_shellbox_accepted,
          tyc_marketshell_accepted: this.completeRegister.value.tyc_marketshell_accepted,
          cellphone: {
            intCode: '549',
            areaCode: this.completeRegister.value.areaCode,
            number: this.completeRegister.value.number
          }
        },
        optIns: [
          {
            accepted: this.completeRegister.value.optin
          }
        ],
        consumers: []
      },
      password: this.completeRegister.value.password,
      confirmPassword: this.completeRegister.value.confirmPassword
    };
  
    this.authService.completeRegister(registerData).subscribe({
      next: () => {
        this.registerIn = false;
        this.successRegister = true;
        this.errorRegister = null;
      },
      error: (error) => {
        this.handleError(error);
      },
    });    
  }
  
  private handleError(error: any): void {
    this.errorRegister = error.error.message || 'Hubo un problema, vuelva a intentar en unos momentos.';
    this.registerIn = false;
    this.successRegister = false;
  }


  closeLogin(): void {
    document.body.classList.remove('noScroll');
    const modal = document.querySelector('.modal-login') as HTMLElement;
    if (modal) {
        modal.classList.remove('visible');
    }
    this.close.emit();
  }

  getPartialMail(): string {
    const email = this.completeRegister.value.email;
    if (email) {
      const [name, domain] = email.split('@');
      return `${name.substring(0, 3)}***@${domain}`;
    }
    return '';
  }

  backToHome() {
    this.router.navigate(['/']);
    this.closeLogin();
  }
}